import { toast } from 'react-toastify'
import {
  getAllPoliciesCount,
  getAllSignupCount,
  getAllStatsCount,
  getProfileStats,
  getWhistleAndIncidentsCount,
} from '../../api/dashboard/home'

interface signupsInterface {
  month: string
  count: string
}

interface signupsInterfaceResponse {
  status: string
  data: signupsInterface[]
}

export interface IncidentItem {
  id: string
  reportNo: number
  closeDate: string | null
  schoolId: string
  subject: string
  reportType: string
  status: string
  isDeleted: boolean
  email: string
  description: string
  createdBy: string | null
  updatedBy: string | null
  updatedAt: string
  createdAt: string
  schoolName: string
}

export interface WhistleBlowingItem {
  id: string
  schoolId: string
  closeDate: string | null
  reportNo: number
  createdBy: string
  candidate: string
  employer: string
  severity_level: string
  overview: string
  status: string
  isDeleted: boolean
  updatedBy: string | null
  createdAt: string
  updatedAt: string
  receivedDate: string | null
  receivedBy: string | null
  supportRequirmentRating: string | null
  immediateActionTaken: string | null
  furtherActionRequired: string | null
  monitoringRequired: string | null
  conclusionOfOutcome: string | null
  schoolName: string
}

export interface GraphItem {
  month: string
  count: string
}

export interface Incident {
  Incident: IncidentItem[]
}

export interface WhistleBlowing {
  whistleBlowing: WhistleBlowingItem[]
}

export interface Graph {
  graph: {
    Incidents: GraphItem[]
    whistleBlowing: GraphItem[]
  }
}

export interface whistleIncidentInterface {
  Incident: IncidentItem[]
  whistleBlowing: WhistleBlowingItem[]
  graph: {
    Incidents: signupsInterface[]
    whistleBlowing: signupsInterface[]
  }
}

export interface whistleIncidentResponse {
  status: string
  data: whistleIncidentInterface
}

interface NearExpiryPolicyItem {
  id: string
  schoolId: string
  title: string
  description: string
  isDeleted: boolean
  policyDocument: string
  status: string
  updatedAt: string
  createdAt: string
  lastReviewDate: string
  nextReviewDate: string
}

export interface PolicyTrackingItem {
  expired: number
  publish: number
  unpublish: number
  [key: string]: number
}

interface policyResponse {
  nearExpiryPolicies: NearExpiryPolicyItem[]
  policyTracking: PolicyTrackingItem
}

interface policyCountInterfaceResponse {
  status: string
  data: {
    nearExpiryPolicies: NearExpiryPolicyItem[]
    policyTracking: PolicyTrackingItem
  }
}

interface statsInterface {
  users: {
    status: string
    count: string
  }[]
  meetings: {
    count: string
  }
  lastMonthMeetings: {
    count: string
  }
  incidents: {
    count: string
  }
  whistleBlowingReports: {
    count: string
  }
  incidentsClosedLastWeek: {
    count: string
  }
  whistleBlowingClosedLastWeek: {
    count: string
  }
}

interface statsInterfaceResponse {
  status: string
  data: statsInterface
}

interface profileStats {
  totalProfileComplete: number
  totalTrainingRecordComplete: number
  totalSafeguardingRecordComplete: number
}

interface profileResponse {
  status: string
  data: profileStats
}

export const getSignupApiCount = async (
  schoolData: string[]
): Promise<signupsInterface[]> => {
  const response = (await getAllSignupCount(
    schoolData
  )) as signupsInterfaceResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getWhistleAndIncident = async (
  data: string[]
): Promise<whistleIncidentInterface> => {
  const response = (await getWhistleAndIncidentsCount(
    data
  )) as whistleIncidentResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getPolicyCount = async (
  data: string[]
): Promise<policyResponse> => {
  const response = (await getAllPoliciesCount(
    data
  )) as policyCountInterfaceResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getStatsCount = async (
  data: string[]
): Promise<statsInterface> => {
  const response = (await getAllStatsCount(data)) as statsInterfaceResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getProfileStatsCount = async (
  data: string[]
): Promise<profileStats> => {
  const response = (await getProfileStats(data)) as profileResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
